import { useMemo } from "react";
import { createHashRouter, RouterProvider } from "react-router-dom";
import { AppWrapper } from "../components/layout/AppWrapper";
import { paths } from "../config/paths";
import { BeautyProfilerHome } from "./beauty-profiler/BeautyProfilerHome";
import { BeautyProfilerProfiler } from "./beauty-profiler/profiler/BeautyProfilerProfiler";
import { FragranceProfilerHome } from "./fragrance-profiler/FragranceProfilerHome";
import { Home } from "./home/Home";
import { LooksGalleryHome } from "./looks-gallery/LooksGalleryHome";
import { FragranceProfilerProfiler } from "./fragrance-profiler/profiler/FragranceProfilerProfiler";
import { BeautyServices } from "./looks-gallery/beauty-services/BeautyServices";
import { LooksGallery } from "./looks-gallery/looks-gallery/LooksGallery";

export const createAppRouter = () =>
  createHashRouter([
    {
      path: paths.app.path,
      element: <AppWrapper />,
      children: [
        {
          path: paths.app.path,
          element: <Home />,
        },
        {
          path: paths.beautyProfiler.path,
          element: <BeautyProfilerHome />,
        },
        {
          path: paths.beautyProfiler.profiler.path,
          element: <BeautyProfilerProfiler />,
        },
        {
          path: paths.looksGallery.path,
          element: <LooksGalleryHome />,
        },
        {
          path: paths.looksGallery.beautyServices.path,
          element: <BeautyServices />,
        },
        {
          path: paths.looksGallery.looksGallery.path,
          element: <LooksGallery />,
        },
        {
          path: paths.fragranceProfiler.path,
          element: <FragranceProfilerHome />,
        },
        {
          path: paths.fragranceProfiler.profiler.path,
          element: <FragranceProfilerProfiler />,
        },
      ],
    },
  ]);

export const AppRouter = () => {
  const router = useMemo(() => createAppRouter(), []);
  return <RouterProvider router={router} />;
};